var isUnitTesting = function isUnitTesting() {
  return !!process.env.JEST_WORKER_ID;
};

export default isUnitTesting;